import { Component, Input, SimpleChanges } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { phosphorCaretRight } from '@ng-icons/phosphor-icons/regular';
import { SmartLink } from '../../models/smart-link';
import { Recommendation } from '../../interfaces/recommendation';
import { RouterModule } from '@angular/router';
import { StandardButtonDirective } from '../../shared/directives/standard-button.directive';
import { Message } from '../../generated-api-proxy';
import { Brand } from 'src/brands/brand';
import { ParentMessengerService } from '../../services/parent-messenger.service';

@Component({
  selector: 'app-smart-link',
  standalone: true,
  imports: [RouterModule, NgClass, NgTemplateOutlet, NgIconComponent, StandardButtonDirective],
  viewProviders: [provideIcons({ phosphorCaretRight })],
  templateUrl: './smart-link.component.html',
  styleUrl: './smart-link.component.scss'
})
export class SmartLinkComponent {
  @Input() link?: SmartLink;

  /** 'button' shows the link text in a standard button, 'chevron' a round icon-only link */
  @Input() variant: 'button' | 'chevron' = 'button';

  @Input() recommendation?: Recommendation | null;

  @Input() message?: Message | null;

  constructor(public parentMessengerService: ParentMessengerService) { }

  async ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName == "recommendation" && changes[propName].currentValue) {
        this.link = SmartLink.fromRecommendation(changes[propName].currentValue);
      }

      if (propName == "message" && changes[propName].currentValue) {
        this.link = SmartLink.fromMessage(changes[propName].currentValue);
      }
    }
  }

  public navigate(link: string | undefined) {
    this.parentMessengerService.navigate(link);
  }
}
